import React, { createContext } from 'react';

type DropDownContextTypes = {
  onClose?: () => void;
}

export const DropDownContext = createContext<DropDownContextTypes | undefined>(undefined);
DropDownContext.displayName = 'DropDownContext';
